import { useEffect } from "react";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from 'react-ga4';
import { BrowserView, MobileView } from "react-device-detect";
import { RecitationDetailMobile } from "./recitationDetailMobile";
import { RecitationDetailWeb } from "./recitationDetailWeb";

const RecitationDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Recitation Submission",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <RecitationDetailWeb/>
      </BrowserView>
      <MobileView>
        <RecitationDetailMobile/>
      </MobileView>
    </>
  );
}

export default RecitationDetail;